import { GET_PRODUCTS, PRODUCTS_ERROR } from "./types";
import { firebase } from "../../firebase";

export const getProducts = idCategory => async dispatch => {
  try {
    let db = firebase.firestore();
    let products = [];
    await db
      .collection("products")
      .where(idCategory, "==", true)
      .where("type", "==", "arrangement")
      .get()
      .then(querySnapshot1 => {
        querySnapshot1.docs.map(doc => {
          return products.push({ id: doc.id, data: doc.data() });
        });
      });
    products.sort((a, b) => {
      return a.data.position - b.data.position;
    });
    dispatch({
      type: GET_PRODUCTS,
      payload: products
    });
  } catch (error) {
    dispatch({
      type: PRODUCTS_ERROR,
      payload: error.message
    });
  }
};

export const getAllProducts = () => async dispatch => {
  try {
    let db = firebase.firestore();
    let products = [];
    await db
      .collection("products")
      .where("type", "==", "arrangement")
      .get()
      .then(querySnapshot1 => {
        querySnapshot1.docs.map(doc => {
          return products.push({ id: doc.id, data: doc.data() });
        });
      });
    products.sort((a, b) => {
      return a.data.position - b.data.position;
    });
    dispatch({
      type: GET_PRODUCTS,
      payload: products
    });
  } catch (error) {
    dispatch({
      type: PRODUCTS_ERROR,
      payload: error.message
    });
  }
};
